import { render, staticRenderFns } from "./PanelInfo.vue?vue&type=template&id=348e243c"
import script from "./PanelInfo.vue?vue&type=script&lang=js"
export * from "./PanelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348e243c')) {
      api.createRecord('348e243c', component.options)
    } else {
      api.reload('348e243c', component.options)
    }
    module.hot.accept("./PanelInfo.vue?vue&type=template&id=348e243c", function () {
      api.rerender('348e243c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/accounts/PanelInfo.vue"
export default component.exports